import type { Framework, VenueCode, VenueConfig, VenueId } from '../types';

export const VENUE_IDS = [
    'beat',
    'afas-dome',
    'sportpaleis',
    'lotto-arena',
    'forest-national',
    'trixxo-arena',
    'stadsschouwburg-antwerp',
    'capitole-ghent',
    'trixxo-theater',
    'beat-tickets',
    'channel-business',
    'channel-corporate',
] as const;

export const VENUE_ONLY_IDS = [
    'beat',
    'afas-dome',
    'sportpaleis',
    'lotto-arena',
    'forest-national',
    'trixxo-arena',
    'stadsschouwburg-antwerp',
    'capitole-ghent',
    'trixxo-theater',
    'beat-tickets',
] as const;

export const VENUE_ONLY_CODE: VenueCode[] = [
    'BT',
    'AD',
    'AS',
    'LA',
    'VN',
    'TA',
    'SA',
    'CG',
    'TT',
];

export const VENUE_CODE: Record<VenueId, VenueCode> = {
    beat: 'BA',
    'beat-tickets': 'BT',
    sportpaleis: 'AS',
    'afas-dome': 'AD',
    'lotto-arena': 'LA',
    'forest-national': 'VN',
    'trixxo-arena': 'TA',
    'stadsschouwburg-antwerp': 'SA',
    'capitole-ghent': 'CG',
    'trixxo-theater': 'TT',
    'channel-business': 'BU',
    'channel-corporate': 'CC',
};

export const VENUE_LOCATION: Record<VenueId, string> = {
    beat: 'antwerp',
    'beat-tickets': 'antwerp',
    sportpaleis: 'antwerp',
    'lotto-arena': 'antwerp',
    'stadsschouwburg-antwerp': 'antwerp',
    'forest-national': 'brussels',
    'trixxo-arena': 'hasselt',
    'trixxo-theater': 'hasselt',
    'capitole-ghent': 'ghent',
    'channel-business': 'ghent',
    'afas-dome': 'antwerp',
    'channel-corporate': 'antwerp',
} as const;

export const venueConfig = (
    id: VenueId,
    framework: Framework = 'next_public'
): VenueConfig => ({
    id,
    code: VENUE_CODE[id],
    position: VENUE_IDS.indexOf(id),
    url: process.env[
        `${framework.toUpperCase()}_${id
            .replaceAll('-', '_')
            .toUpperCase()}_URL`
    ],
});

export const VENUE_AD_UNIT_ID = {
    'afas-dome': 'afasdome',
    'lotto-arena': 'lotto',
    'forest-national': 'forest',
    'trixxo-arena': 'trixxo',
    'stadsschouwburg-antwerp': 'stadss',
    'capitole-ghent': 'capitole',
    'trixxo-theater': 'trixth',
} as const;

export type VenueAdUnitIdUnion =
    (typeof VENUE_AD_UNIT_ID)[keyof typeof VENUE_AD_UNIT_ID];
